import React from 'react';
import './BookingPage.css'
import Skeleton from 'react-loading-skeleton';
function BookingPage(props) {


    return (
        <>
            <div
                className="Container-Tile"
                style={{ height: 250 }}
                >
                <div className="ContainerFlex">
                    <div
                    className="ContainerImage"
                    style={{ padding: "15px 10px 10px 10px" }}
                    >
                    <Skeleton
                        style={{ width: "100%", height: "165px" }}
                    />
                    </div>
                    <div
                    className="ContainerContent"
                    style={{ padding: "10px 10px 10px 40px" }}
                    >
                    <div
                        className="nameContainer"
                        style={{ width: "100%" }}
                    >
                        <div className="paymakeFlex appendBottom5">
                        <h3 className="latoBlack font22 blackText">
                            <Skeleton
                            style={{ width: "200px" }}
                            />
                        </h3>
                        <span
                            className="sRating"
                            style={{
                            display: "inline-flex",
                            marginTop: "5px",
                            marginLeft: "10px",
                            }}
                        >
                            <Skeleton
                            style={{ width: "100px" }}
                            />
                        </span>
                        </div>
                        <p>
                        <Skeleton style={{ width: "300px" }} />
                        </p>
                        <h3
                        className="latoBlack font22 blackText"
                        style={{
                            marginTop: 10,
                            fontSize: 18,
                            fontWeight: "bold",
                        }}
                        >
                        <Skeleton style={{ width: "150px" }} />
                        </h3>

                        <div class="chkContBooking">
                        <div class="chkCont__col">
                            <div class="paymakeFlex column">
                            <span class="font10 grayText appendBottom3">
                                <Skeleton
                                style={{ width: 150 }}
                                />
                            </span>
                            <span class="latoBlack font24 blackText appendBottom3">
                                <Skeleton
                                style={{ width: 150 }}
                                />
                            </span>
                            <span class="font10 grayText 444">
                                <Skeleton
                                style={{ width: 150 }}
                                />
                            </span>
                            </div>
                            <div class="chkCont__night">
                            <span>
                                <Skeleton
                                style={{ width: 150 }}
                                />
                            </span>
                            </div>
                            <div class="paymakeFlex column">
                            <span class="font10 grayText appendBottom3">
                                <Skeleton
                                style={{ width: 150 }}
                                />
                            </span>
                            <span class="latoBlack font24 blackText appendBottom3">
                                <Skeleton
                                style={{ width: 150 }}
                                />
                            </span>
                            <span class="font10 grayText">
                                <Skeleton
                                style={{ width: 150 }}
                                />
                            </span>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>


        </>
    )
}

export default BookingPage;
